import React, { Component } from "react";
import { Table, Spin, Button, message } from "antd"; 
import { API } from "../../../API/API";
import { baseConfig } from "../../../Config/Config";
import UserContext from "../../UserContext/UserContext";

class StakeHolderSecondRoundEvaluationTable extends Component {
    state = {
      invitationid: this.props.invitationid,
      tblvendor: [],
      tblcriteria: [],
      tblevaluation: [],
      loading: true,
      selectedVendorKeys: [],
      selectedVendors: [],
    };

  async componentDidMount() {
    try {
      // Fetch Invitation's vendors
      API.get("/getInvitationsVendorListForNextRound?invitationid=" + this.state.invitationid + "&stage=2").then(
        (response) => {
            if (response.status === 200) {
            this.setState((prevState) => ({
                tblvendor: response.data.retData,
            }));
            }
        }
      );

      // Fetch criteria of invitation  
      API.get("/getCriteriaList?invitationid=" + this.state.invitationid).then(
        (response) => {
            if (response.status === 200) {
            this.setState((prevState) => ({
                tblcriteria: response.data.retData,
            }));
            }
        }
      );

      // Fetch evaluations by members
      API.get("/getInvitationsVendorEvaluationList?invitationid=" + this.state.invitationid).then(
        (response) => {
            if (response.status === 200) {
            this.setState((prevState) => ({
                tblevaluation: response.data.retData,
            }));
            }
        }
      );
  }
  catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ loading: false });
    }
  }

  onSaveClick = async () => {
      const { selectedVendors, tblvendor } = this.state;
    
      const vendorsWithSelection = tblvendor.map((vendor) => {
          const isSelected = selectedVendors.some((selected) => Number(selected.key) === Number(vendor.vendorid));
          
          return {
            ...vendor,
            won_second_round: isSelected ? 1 : 0, // 1 for selected, 0 for not selected
            createdby_second_round: this.context.userid,
            stage:2,
          };
      });
      try {
          // Send data to the API
          let bodySubmit = [...vendorsWithSelection]; 
          console.log("submitted data= ", bodySubmit)
          const response = await API.post("/saveInvitationVendorRoundSelectionResult", bodySubmit);
  
          if (response.status === 200) {
            message.success("Шалгаруулалт амжилттай!");
            this.props.showForm(false, 0);
          } else {
            message.error("Алдаа гарлаа. Дахин оролдоно уу.");
          }
        } catch (error) {
          console.error("Error updating vendor selection:", error);
          message.error("Алдаа гарлаа. Дахин оролдоно уу.");
        }
    };


  render() 
  {
    const { tblvendor, tblcriteria, tblevaluation, loading } = this.state;

    const dataSource = tblvendor.map((vendor) => {
      const vendorEvals = tblevaluation.filter(e => e.vendorid === vendor.vendorid);
      const empIds = [...new Set(vendorEvals.map(e => e.empid))];

      // Child rows per empid
      const children = empIds.map((empid) => {
        const empEvals = vendorEvals.filter(e => e.empid === empid);

        const row = {
          key: `${vendor.vendorid}-${empid}`,
          empid: empid,
          createdby: empEvals[0]?.createdby ?? '-', // Take from first matching record
        };

        tblcriteria.forEach(criteria => {
          const evalMatch = empEvals.find(e => e.criteriaid === criteria.criteriaid);
          row[criteria.criteriaid] = evalMatch ? evalMatch.result : '-';
        });

        return row;
    });

    // Compute average score per criteria
    const avgRow = {
      key: `${vendor.vendorid}`,
      vendorname: vendor.vendorname,
      children,
    };

    tblcriteria.forEach(criteria => {
      const points = vendorEvals
        .filter(e => e.criteriaid === criteria.criteriaid)
        .map(e => e.result);

      const avg = points.length > 0
        ? (points.reduce((sum, p) => sum + p, 0) / points.length).toFixed(2)
        : '-';

      avgRow[criteria.criteriaid] = avg;

    });

    return avgRow;
    });
  // checkbox for selecting winner vendors
    const rowSelection = {
      selectedRowKeys: this.state.selectedVendorKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          selectedVendorKeys: selectedRowKeys,
          selectedVendors: selectedRows,
        });
      },
      getCheckboxProps: (record) => ({
        disabled: !!record.empid, // disable checkbox on evaluator rows (children)
      }),
    };


  const columns = [
    {
      title: "Оролцсон компани",
      dataIndex: "vendorname",
      key: "vendorname",
      render: (text) => text ?? '', // Parent rows
    },  
    {
      title: "Үнэлсэн ажилтан",
      dataIndex: "createdby",
      key: "createdby",
      render: (text) => text ?? '',
    },
    ...tblcriteria.map(criteria => ({
      title: criteria.criteriatypename,
      dataIndex: criteria.criteriaid,
      key: criteria.criteriaid,
    })),
  ];

  return (
    <div>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        bordered
        rowKey="key"
        rowSelection={rowSelection}
      />
      <div>
        <Button
          type="primary"
          style={{ marginTop: 16 }}
          onClick={this.onSaveClick}>
            III шатанд шалгаруулах
        </Button>
      </div>
    </div>
  );

  }
}

export default StakeHolderSecondRoundEvaluationTable;
